import { render, staticRenderFns } from "./ClientsListFilters.vue?vue&type=template&id=7d2872e6&"
import script from "./ClientsListFilters.vue?vue&type=script&lang=js&"
export * from "./ClientsListFilters.vue?vue&type=script&lang=js&"
import style0 from "./ClientsListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports